import React, { ReactNode, useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";
import FleetDailyReport from "./FleetDailyReport";
import GpsReport from "./GpsReport";
import OverSpeedingReport from "./OverSpeedingReport";
import DistanceInsights from "./DistanceInsights";
import DriverBehaviorReport from "./DriverBehaviorReport";
import AlarmReports from "./AlarmReports";
import IotReports from "./IotReports";
import { useLocation } from "react-router-dom";

interface TabPanelProps {
  children?: ReactNode;
  value: number;
  index: number;
}
// Component for rendering tables
const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const MultiTableTabs = () => {
  const location = useLocation();
  const {
    tabIndex: initialTabIndex,
    countType,
    countValue,
  } = location.state || {};
  const [tabIndex, setTabIndex] = useState<number>(initialTabIndex || 0);

  const handleTabChange = (event: any, newValue: any) => {
    setTabIndex(newValue);
  };
  useEffect(() => {
    if (initialTabIndex !== undefined && initialTabIndex !== 4) {
      setTabIndex(initialTabIndex);
    }
  }, [initialTabIndex]);

  return (
    <div>
      <AppHeader />
      <Box sx={{ width: "100%" }}>
        <div className="flex bg-[#D8FFEA] px-8  py-8 pb-20">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            centered
            TabIndicatorProps={{
              style: {
                backgroundColor: "#06B681", // Underline color
                fontWeight: "bold",
                color: "#06B681",
              },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none", // Optional: Prevent uppercase text
                fontWeight: "bold", // Bold text for selected tab
                color: "#06B681",
              },
              "& .Mui-selected": {
                color: "#06B681", // Selected tab text color
              },
            }}
          >
            <Tab label="Fleet Daily Summary Report" />
            <Tab label="GPS Report" />
            {/* <Tab label="Over Speeding Report" /> */}
            <Tab label="Distance Insights" />
            <Tab label="Driver Behavior Report" />
            {/* <Tab label="Alarm Reports" /> */}
            {tabIndex === 4 && <Tab label="IOT Reports" />}
          </Tabs>
        </div>
        {/* Fleet Daily Summary Report Tab */}
        <div className="container px-4 relative bottom-16">
          <TabPanel value={tabIndex} index={0}>
            <FleetDailyReport />
          </TabPanel>

          {/* GPS Report Tab */}
          <TabPanel value={tabIndex} index={1}>
            <GpsReport />
          </TabPanel>

          {/* Over Speed Report Tab */}
          {/* <TabPanel value={tabIndex} index={2}>
       <OverSpeedingReport/>
      </TabPanel> */}
          <TabPanel value={tabIndex} index={2}>
            <DistanceInsights />
          </TabPanel>
          <TabPanel value={tabIndex} index={3}>
            <DriverBehaviorReport />
          </TabPanel>
          {/* <TabPanel value={tabIndex} index={5}>
       <AlarmReports/>
      </TabPanel> */}
          {tabIndex === 4 && (
            <TabPanel value={tabIndex} index={4}>
              <IotReports />
            </TabPanel>
          )}
        </div>
      </Box>
    </div>
  );
};

export default MultiTableTabs;
